import { useEffect, useState } from 'react'
import {useParams} from 'react-router-dom'
import useTabs from '../../../../services/customHooks/useTabs'

const useTabsNav = () => {
    const { tabName, id } = useParams()
    const {tabs} = useTabs()
    const [activeTabValue, setActiveTabValue] = useState(0)

    useEffect(() => {
        // tabs usually have names as tab0, tab1 and so on
        // to have correct "selected" class on the tabs need to pass value as extracted number
        if (tabName) {
          const idx = tabName.search(/\d/);
          const tabOrder = Number(tabName[idx]);
          const normalizedValue = !Number.isNaN(tabOrder) ? tabOrder : 0

          setActiveTabValue(normalizedValue)
        } else if (window.location.pathname?.includes('approveDashboard')) {
          const dashboardDataTab = 5;
          setActiveTabValue(dashboardDataTab);
        } else {
          setActiveTabValue(0);
        }
    }, [tabName])

    return {tabs, id, tabName, activeTabValue}
}

export default useTabsNav
